import React, { useState } from "react";
import { ArrowRight, Menu, X } from "lucide-react";
import logo from "../images/logo.jpg";

const navItems = [
  { label: "Home", href: "#" },
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Highlights", href: "#highlights" },
  { label: "Offerings", href: "#offerings" },
  { label: "Applications", href: "#applications" },
  { label: "Catalogue", href: "#catalogue" },
  { label: "Contact", href: "#contact" }
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur supports-[backdrop-filter]:bg-black/30 bg-black/20 border-b border-white/10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-24 items-center justify-between">
          {/* Logo */}
          <a href="#" className="group inline-flex items-center gap-2">
            <img
              src={logo}
              alt="logo"
              className="h-20 w-24"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            {navItems.map((n) => {
              const isHome = n.href === "#";
              return (
                <a
                  key={n.label}
                  href={n.href}
                  className={`text-sm transition-colors ${
                    isHome ? "text-yellow-300 font-semibold" : "text-neutral-300 hover:text-yellow-200"
                  }`}
                >
                  {n.label}
                </a>
              );
            })}
            <a
              href="#catalogue"
              className="inline-flex items-center gap-2 rounded-full border border-yellow-400/50 bg-gradient-to-br from-yellow-400/20 to-amber-400/10 px-4 py-2 text-sm font-medium text-yellow-200 shadow-[0_0_0_1px_rgba(250,204,21,0.25)_inset] hover:from-yellow-400/30 hover:to-amber-400/20"
            >
              Download Catalogue <ArrowRight className="h-4 w-4" />
            </a>
          </nav>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden text-yellow-300"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle Menu"
          >
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="absolute top-0 left-0 z-40 w-full h-screen bg-white text-black transition-transform duration-300 ease-in-out animate-slide-in">
          <div className="flex justify-between items-center px-4 py-4 border-b border-gray-200">
            <img
              src={logo}
              alt="logo"
              className="h-16 w-20"
            />
            <button onClick={() => setMenuOpen(false)} aria-label="Close Menu">
              <X className="w-6 h-6 text-black" />
            </button>
          </div>

          <div className="px-4 py-6 space-y-4">
            {navItems.map((n) => {
              const isHome = n.href === "#";
              return (
                <a
                  key={n.label}
                  href={n.href}
                  onClick={() => setMenuOpen(false)}
                  className={`block text-base font-medium transition-colors ${
                    isHome ? "text-yellow-600 font-semibold" : "hover:text-yellow-600"
                  }`}
                >
                  {n.label}
                </a>
              );
            })}

            <a
              href="#catalogue"
              onClick={() => setMenuOpen(false)}
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-yellow-500 bg-yellow-100 px-4 py-2 text-sm font-medium text-yellow-800 hover:bg-yellow-200 transition-all"
            >
              Download Catalogue <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
